<li class="wm-studio-user-info dropdown org-profile"  #dropdown="bs-dropdown"  dropdown dropdownToggle (click)="false"  >
 <!-- <span class="name white-space: pre;" *ngIf="selectedOrganization?.mode === 'OWN'" title="{{user.displayName}}">{{user.displayName}}</span>
  <span class="name white-space: pre;" *ngIf="selectedOrganization?.mode === 'ORG'" title="{{selectedOrganization?.displayName}}">{{selectedOrganization?.displayName}}</span>  -->
  <a class="dropdown-toggle" name="wm-user-info-dropdown"  >
    <p class="title">
      <wms-user-avatar name="wm-user-avatar-icon" [displayName]="user.displayName" [emailId]=" user.email"></wms-user-avatar>
      </p>
    <span class="caret"></span>
    </a>
  <ul id="dropdown-basic" *dropdownMenu class="user-actions wm-default-menu dropdown-menu dropdown-menu-right" role="menubar">
<!--    // Personal Account selected-->
    <li class="wm-user-details self-account separator" *ngIf="selectedOrganization?.mode === 'OWN' || user.enterpriseMode === 'OWN'">
      <p class="title selforg-icon">
        <wms-user-avatar name="wm-user-avatar-icon" [displayName]="user.displayName" [emailId]=" user.email"></wms-user-avatar>
        </p>
      <p name="wm-user-name"  title="{{displayName}}" class="org-name text-capitalize">{{displayName}}</p>
      <p name="wm-user-mail" class="wm-studio-user-mail" title="{{user.email}}">{{user.email}}</p>
      <p class="wm-studio-user-name">({{locale.LABEL_PERSONAL}})</p>
      </li>
<!--    // Organization selected-->
    <li class="wm-user-details org-account separator" *ngIf="selectedOrganization?.mode === 'ORG' || user.enterpriseMode === 'ORG'">
      <p class="title">
        <i name="wm-org-icon" class="wm-icon wms wms-group org-icon"></i>
        </p>
      <p class="org-name"><span class="text-capitalize" title="{{selectedOrganization?.displayName}}">{{selectedOrganization?.displayName || user.entName}}</span></p>
      <hr>
      <p name="wm-user-name" class="wm-studio-user-name text-capitalize" title="{{displayName}}">{{displayName}}</p>
      <p name="wm-user-mail" class="wm-studio-user-mail" title="{{user.email}}">{{user.email}}</p>
      </li>
<!--    // Allow user to switch to Personal Account-->
    <li class="separator" *ngIf="!project && selfOrg && selectedOrganization?.entId !== selfOrg.entId">
      <a href="javascript:void(0)" (click)="switchOrganization(selfOrg.entId)" title="{{displayName}}" class="self-org">
        <div class="org-icon">
          <wms-user-avatar name="wm-user-avatar-icon" [displayName]="user.displayName" [emailId]="user.email"></wms-user-avatar>
        </div>
        <div class="org-name"><p class="text-capitalize">{{displayName}}</p><p>({{locale.LABEL_PERSONAL}})</p></div>
        </a>
      </li>
<!--    // list of organizations except self org-->


    <li *ngIf="!project && organizations.length > 1" class="org-list separator" [ngClass]="{'org-list-max': selectedOrganization?.entId === selfOrg.entId}">

      <a href="javascript:void(0)" (click)="switchOrganization(org.entId)" title="{{org.displayName}}"  *ngFor="let org of organizations" class="user-organizations">
        <i name="wm-org-icon" class="wm-icon wms wms-group org-icon"></i><span class="org-name">{{org.displayName}}</span></a>
      </li>
    <li *ngIf="!project"><a *wmsFeature="preferences.workspace.user.edit" name="wm-go-to-profile" href="javascript:void(0)"  (click)="goToProfile()" title="{{locale.LABEL_HEADER_USER_PROFILE}}"><i class="wm-icon wms wsm-profile"></i><span class="menu-name">{{locale.LABEL_HEADER_USER_PROFILE}}</span></a></li>
    <li class="wm-user-resend-email separator" *ngIf="!user.verified && subscriptionDetails.accountMode === 'TRIAL'">
      <div>{{locale.MESSAGE_HEADER_RESEND_EMAIL_TEXT}}</div>
      <a name="wm-resend-email-verification" href="javascript:void(0)"
      (click)="resendVerificationEmail()" title="{{locale.LABEL_HEADER_RESEND_EMAIL_VERIFICATION}}">
      <span>{{locale.LABEL_HEADER_RESEND_EMAIL_VERIFICATION}}</span>
      </a>
      </li>
    <li *ngIf="!project"><a *wmsFeature="preferences.workspace.user.account" name="wm-go-to-account" href="javascript:void(0)"  (click)="goToAccount()" title="{{locale.LABEL_HEADER_USER_PROFILE}}"><i name="wm-account-icon" class="wm-icon wms wms-account"></i><span class="menu-name">{{locale.LABEL_HEADER_ACCOUNT}}</span></a></li>
    <li><a *wmsFeature="preferences.workspace.user.logout" name="wm-logout" href="javascript:void(0)" (click)="logout()" title="{{locale.LABEL_HEADER_USER_LOGOUT}}"><i class="wm-icon wms wms-log-out"></i><span class="menu-name">{{locale.LABEL_HEADER_USER_LOGOUT}}</span></a></li>
    <li>
      <a class="wm-logo-container" name="wm-about-logo" title="{{locale.LABEL_CURRENT_VERSION}}" (click)="openAboutDialog()">
        <img class="brand-logo" alt="Brand Logo" [src]="'assets/logo.png'| versionManager"/>
        <span>{{locale.LABEL_ABOUT_STUDIO}}</span>
        </a>
      </li>
    </ul>

</li>

<wms-dialog id="aboutDialog" [content]="aboutDialog" name="wm-build-logo-dialog" customClasses="about-container-dialog  wm-studio-dialog">
</wms-dialog>

<ng-template #aboutDialog >
  <wms-about-dialog [studioInfo]="studioInfo"  (handleClose)="closeDialogWithId('aboutDialog')"></wms-about-dialog>
</ng-template>

